import { createSelector } from 'reselect';

const selectDBACatalogs = (state: any) => state.dbaCatalogs;


export const selectDBACatalogsCurrentItem = createSelector([selectDBACatalogs], (dbaCatalogs) => dbaCatalogs.current);

export const selectDBACatalogsListItems = createSelector([selectDBACatalogs], (dbaCatalogs) => dbaCatalogs.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectDBACatalogsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDBACatalogsQueryItems = createSelector([selectDBACatalogs], (dbaCatalogs) => dbaCatalogs.query);

export const selectDBACatalogsCreatedItem = createSelector([selectDBACatalogs], (dbaCatalogs) => dbaCatalogs.create);

export const selectDBACatalogsUpdatedItem = createSelector([selectDBACatalogs], (dbaCatalogs) => dbaCatalogs.update);

export const selectDBACatalogsReadItem = createSelector([selectDBACatalogs], (dbaCatalogs) => dbaCatalogs.read);

export const selectDBACatalogsDeletedItem = createSelector([selectDBACatalogs], (dbaCatalogs) => dbaCatalogs.delete);

export const selectDBACatalogsSearchedItems = createSelector([selectDBACatalogs], (dbaCatalogs) => dbaCatalogs.search);

export const selectDBACatalogsItemsCount = createSelector([selectDBACatalogs], (dbaCatalogs) => dbaCatalogs.count);

export const selectDBACatalogsItemsFilter = createSelector([selectDBACatalogs], (dbaCatalogs) => dbaCatalogs.filter);